import CXMApiClient from "../CXMApiClient";
import Vue from "vue";
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";

function initialState() {
  return {
    ConfirmLeadStatusModal: {
      ShowModal: false,
      type: "",
      modalData: null
    },
    LeadSources: [],
    ActiveCRMLeads: [],
    isCallTracking: false
  };
}

const state = initialState();

const getters = {
  isCallTracking: function (state) {
    return state.isCallTracking;
  }
};

const actions = {
  setConfirmLeadStatusModal(context, val) {
    context.commit("ConfirmLeadStatusModalShowModal", val);
  },
  async startOutboundCall(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    context.commit("UpdateIsCallTracking", true);
    let cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient
      .ProcessRequest(
        "POST",
        "crm/contacts/" + request.contactId + "/actions/start_outbound_call",
        request,
        scope
      )
      .catch(ex => {
        return null;
      });
    return response && response.data ? response.data.data : null;
  },
  getActiveLeads(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("POST", "/api/CrmLead/Search", request, scope)
        .then(resp => {
          if (resp && resp.data) {
            context.commit("setActiveLeads", resp.data);
            resolve(resp.data);
          } else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getCrmLead(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/CrmLead/Search",
          request,
          request.scope ? [request.scope] : []
        )
        .then(resp => {
          if (resp && resp.data) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  async getCrmLeadById(context, request) {
    let cxmApiClient = new CXMApiClient();
    return await cxmApiClient.ProcessRequest("GET", `/api/CrmLead/${request.leadId}`, null, request.scope ? [request.scope] : []).catch(err => err.response);
  },
  saveLead(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("POST", `/api/CrmLead/save`, request, scope)
        .then(resp => {
          if (resp && resp.data) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  updateLeadTypeSource(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "PUT",
          `/api/CrmLead/${request.crmLeadId}/update_type_and_source`,
          request.updateRequest,
          scope
        )
        .then(resp => {
          if (resp && resp.data) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  markLeadLost(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "PUT",
          `/api/CrmLead/${request.crmLeadId}/mark_lost`,
          request,
          scope
        )
        .then(resp => {
          if (resp && resp.data) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  markLeadBad(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "PUT",
          `/api/CrmLead/${request.crmLeadId}/mark_bad`,
          request,
          scope
        )
        .then(resp => {
          if (resp && resp.data) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  markLeadSoldDelivered(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "PUT",
          `/api/CrmLead/${request.crmLeadId}/mark_sold_delivered`,
          request,
          scope
        )
        .then(resp => {
          if (resp && resp.data) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  markLeadSoldPending(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "PUT",
          `/api/CrmLead/${request.crmLeadId}/mark_sold_pending`,
          request,
          scope
        )
        .then(resp => {
          if (resp && resp.data) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  loadLeadSources: function (context, platform) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/CrmLead/leadsource/get",
          platform,
          platform.scope ? [platform.scope] : []
        )
        .then(resp => {
          if (resp && resp.data) {
            context.commit("updateLeadSources", resp.data);
            resolve(resp.data);
          } else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  UpdateIsCallTracking(context, val) {
    context.commit("UpdateIsCallTracking", val);
  },
  async getCrmLeadVoiSoldStatus(context, request) {
    let response = await new CXMApiClient().ProcessRequest(
      "POST",
      "/api/CrmLead/get_leadvoistatus_by_stockno_vin",
      request
    );
    return response && response.data ? response.data.data : [];
  }
};

const mutations = {
  ConfirmLeadStatusModalShowModal(state, val) {
    state.ConfirmLeadStatusModal.ShowModal = val.ShowModal;
    state.ConfirmLeadStatusModal.ModalData = val.ModalData;
    state.ConfirmLeadStatusModal.buttons = val.buttons;
  },
  updateLeadSources: function (state, data) {
    state.LeadSources = data
      ? data.data.sort(HelperFunctions.sortByPropertyAsc("name"))
      : [];
  },
  setActiveLeads(state, val) {
    state.ActiveCRMLeads = val.data;
  },
  UpdateIsCallTracking(state, val) {
    state.isCallTracking = val;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/CrmLead.js